module.exports = __webpack_public_path__ + "img/a533044.jpg";